import OBTDropDownList2 from './OBTDropDownList2';
export default OBTDropDownList2;
